
$(document).ready(function () {
    console.log("mobilefilter loads");

    function isMobileFilterViewport() {
      return window.matchMedia("(max-width: 992px)").matches;
    }

    function openMobileFilters() {
      var $filters = $("#collectionFilters");
      $filters.addClass("popup-overlay active");
      $filters.find(".popup-content").addClass("active");
    }

    function closeMobileFilters() {
      var $filters = $("#collectionFilters");
      $filters.removeClass("active popup-overlay");
      $filters.find(".popup-content").removeClass("active");
    }

    $(document).on("click", ".mobilefilter", function (e) {
      if (!isMobileFilterViewport()) return;
      e.preventDefault();
      e.stopPropagation();
      openMobileFilters();
    });

    $(document).on("click", "#collectionFilters.popup-overlay", function (e) {
      if (!isMobileFilterViewport()) return;
      if ($(e.target).closest(".popup-content").length) return;
      closeMobileFilters();
    });

    $(document).on("click", "#collectionFilters .close", function (e) {
      if (!isMobileFilterViewport()) return;
      e.preventDefault();
      e.stopPropagation();
      closeMobileFilters();
    });

    $(window).on("resize orientationchange", function () {
      if (!isMobileFilterViewport()) {
        closeMobileFilters();
      }
    });

  });
  $(function () {
    //caches a jQuery object containing the header element
    var header = $(".product-topbox");
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 350) {
        header.addClass("fixedbox");
      } else {
        header.removeClass("fixedbox");
      }
    });
  }); 